import Services from '../components/Services.vue'
import { bootstrapPage } from '../bootstrapPage'

bootstrapPage(Services)
